module.exports = __webpack_public_path__ + "img/interviews_blue.3a4aec79.svg";